import React from 'react';
import styles from './VideoSection.module.scss';

const VideoSection = ({ videoUrl }) => {
  return (
    <section className={styles.Container}>
      <iframe
        className={styles.IFrame}
        src={videoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay, clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
        allowFullScreen
        title="YouTube video player"
      />
    </section>
  );
};

export default VideoSection;



// WEBPACK FOOTER //
// ./src/common/components/VideoSection/VideoSection.js